// 生成一个全局变量globalData
let globalData = null
// 生成一个class类
class GlobalStore {
  // 存储方法
  setGlobal(data) {
    globalData = data
  }
  // 读取方法
  getGlobal() {
    const _globalData = {
      user: {},
      token: '',
      source: '',
    }
    return {..._globalData, ...globalData}
  }
}
// 导出一个实例化的对象
export default new GlobalStore()